var _polygon, _polygon2, _line, _line2, _line3, _line4, _polyline, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProductionUnit = (_ref, ref) => {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.1 52.7",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    strokeWidth: 0.6169,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "24.3 52.4 24.3 24.5 0.3 12.4 0.3 40.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "24.3 24.5 24.3 52.4 48.7 40.4 48.7 12.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 36.5,
    x2: 36.5,
    y1: 18.4,
    y2: 46.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 12.2,
    x2: 12.2,
    y1: 18.4,
    y2: 46.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 48.7,
    x2: 24.3,
    y1: 26.7,
    y2: 38.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 24.3,
    x2: 0.3,
    y1: 38.6,
    y2: 26.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: "48.7 12.4 24.7 0.3 0.3 12.4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 36.4,
    x2: 12.4,
    y1: 18.6,
    y2: 6.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 35.9,
    x2: 11.9,
    y1: 6.1,
    y2: 18.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProductionUnit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/production-unit.2a539b35dd2fd0280bdf7ed04552ef36.svg";